<template>
    <div class="card treasury ice-wrap" >
        <button type="button" class="close bnd-close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
            <i class="fas fa-times-circle"></i>
        </button>
        <!-- <div class="card-body">
            <div class="modal-header">
                <h5 class="card-title">Bond Description</h5>
                <p>{{bondDescriptionData.description}}</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                    <i class="fas fa-times-circle"></i>
                </button>
            </div>
            <div class="card-text" style="display:block">
                <ul>
                    <li>Muni Curve Yield On Call :<span>{{muniCurveYieldOnCall ? muniCurveYieldOnCall : 'N/A'}}</span></li>
                    <li>Muni Curve Yield On Maturity :<span>{{muniCurveYieldOnMaturity ? muniCurveYieldOnMaturity : 'N/A'}}</span></li>
                    <li>10 Year Treasury Yield On Call :<span>{{tenYearYieldOnCall ? tenYearYieldOnCall : 'N/A'}}</span></li>
                    <li>10 Year Treasury Yield	On Maturity :<span>{{tenYearYieldOnMaturity ? tenYearYieldOnMaturity : 'N/A'}}</span></li>
                </ul>
              <div v-if="yieldLoader" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

            </div>
        </div> -->
        <div class="bnd">
        <div>
            <h5 class="card-title">Bond Description</h5>
            <p>{{bondDescriptionData.description}}</p>
        </div>
        <!-- <div>
            <h5 class="card-title">Curve Yields</h5>
            <ul>
                <li>Muni Curve Yield On Call :<span>{{muniCurveYieldOnCall ? muniCurveYieldOnCall : 'N/A'}}</span></li>
                <li>Muni Curve Yield On Maturity :<span>{{muniCurveYieldOnMaturity ? muniCurveYieldOnMaturity : 'N/A'}}</span></li>
                <li>10 Year Treasury Yield On Call :<span>{{tenYearYieldOnCall ? tenYearYieldOnCall : 'N/A'}}</span></li>
                <li>10 Year Treasury Yield	On Maturity :<span>{{tenYearYieldOnMaturity ? tenYearYieldOnMaturity : 'N/A'}}</span></li>
            </ul>
            <div v-if="yieldLoader" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
        </div> -->
        </div>
        <p  v-if="maturityErrorMessage" class="bnd-warning">{{maturityErrorMessage}}</p>
        <p  v-if="callErrorMessage" class="bnd-warning">{{callErrorMessage}}</p>
    </div>
</template>
<script>

export default {
    name: 'bondDescription',
    props: [
        'bondDescriptionData',
        'muniCurveYieldOnCall',
        'muniCurveYieldOnMaturity',
        'tenYearYieldOnCall',
        'tenYearYieldOnMaturity',
        'yieldLoader',
        'maturityErrorMessage',
        'callErrorMessage'
        ],
};
</script>